export function checkDateInSemester(dateToCheck) {
  const today = new Date();
  const dateToCheckObejct = new Date(dateToCheck);
  if (today.getMonth() < 6) {
    return dateToCheckObejct.getMonth() < 6 && dateToCheckObejct.getFullYear() === today.getFullYear();
  } else {
    return dateToCheckObejct.getMonth() >= 6 && dateToCheckObejct.getFullYear() === today.getFullYear();
  }
}